import { saveAs } from 'file-saver';
import * as xlsx from 'xlsx';
import { AssetEvent } from '../../core/store/models';
import { purifyCSV } from './csvInjectionPurifier';

function convertAssetLikeToAOA(fields, data, otherCurrency?, assetEventsForAssetId?: { [assetId: number]: AssetEvent }): string[][] {
    const aoa = [];

    const headers = [];
    fields.forEach(field => {
        if (field.canonical_name === 'other_cost' && otherCurrency) {
            headers.push(`Cost (${otherCurrency.accounting_code})`);
        } else {
            headers.push(field.name);
        }
    });
    aoa.push(headers);

    data.forEach(row => {
        const values = [];

        fields.forEach(field => {
            if (field.name === 'Multiple Requests') {
                values.push(row.requestAsset.hasConflict ? 'Conflict' : '');
            } else if (field.name === 'Request Status') {
                values.push(row.requestAsset.approved ? 'Approved' : 'Denied');
            } else if (field.name === 'Sent To') {
                values.push(row.requestAsset.finalApproversSentTo);
            } else if (field.name === 'Qty. on Loan') {
                values.push(assetEventsForAssetId[row.id].qty_on_loan);
            } else if (field.name === 'Qty. Returned') {
                values.push(assetEventsForAssetId[row.id].qty_returned);
            } else if (field.canonical_name === 'other_cost' && otherCurrency) {
                values.push(row.displayFields.other_cost[otherCurrency.id]);
            } else if (field.name === 'Events') {
                if (Array.isArray(row.displayFields[field.canonical_name]) && row.displayFields[field.canonical_name].length) {
                    const events = row.displayFields[field.canonical_name].map(assetEvent => assetEvent?.event?.name);
                    values.push(events.join(','));
                } else {
                    values.push('');
                }
            } else if (row.displayFields) {
                if (Array.isArray(row.displayFields[field.canonical_name])) {
                    values.push(row.displayFields[field.canonical_name].join(','));
                } else {
                    values.push(row.displayFields[field.canonical_name]);
                }
            } else {
                if (Array.isArray(row[field.canonical_name])) {
                    values.push(row[field.canonical_name].join(','));
                } else {
                    values.push(row[field.canonical_name]);
                }
            }
        });
        aoa.push(values);
    });

    return aoa;
}

export function exportCSV(fields, data, filename = 'data', otherCurrency?, assetEventsForAssetId?: { [assetId: number]: AssetEvent }) {
    const aoa = convertAssetLikeToAOA(fields, data, otherCurrency, assetEventsForAssetId);
    const sheet = purifyCSV(xlsx.utils.aoa_to_sheet(aoa));
    const csv = xlsx.utils.sheet_to_csv(sheet);
    const blob = new Blob([csv], { type: 'text/plain;charset=utf-8' });
    saveAs(blob, `${filename}.csv`);
}

export function exportCSVFromAOA(aoa, filename = 'data') {
    const sheet = purifyCSV(xlsx.utils.aoa_to_sheet(aoa));
    const csv = xlsx.utils.sheet_to_csv(sheet);
    const blob = new Blob([csv], { type: 'text/plain;charset=utf-8' });
    saveAs(blob, `${filename}.csv`);
}
